import React, { useEffect } from "react";
import { Container, Row, Col, Navbar, Nav, Form, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import Header from "./Header";
import './Home.css';
import Footer from "./Footer";

export default function Contact() {
    // Internal CSS for scroll animations
    const css = `
        /* base - hidden state */
        .fade-up, .slide-in-left, .slide-in-right {
            opacity: 0;
            transition: all 0.8s cubic-bezier(.22,.9,.29,1);
            will-change: transform, opacity;
        }

        /* fade-up */
        .fade-up {
            transform: translateY(30px);
        }
        .fade-up.animate {
            transform: translateY(0);
            opacity: 1;
        }

        /* slide-in-left */
        .slide-in-left {
            transform: translateX(-40px);
        }
        .slide-in-left.animate {
            transform: translateX(0);
            opacity: 1;
        }

        /* slide-in-right */
        .slide-in-right {
            transform: translateX(40px);
        }
        .slide-in-right.animate {
            transform: translateX(0);
            opacity: 1;
        }

        /* delays you can apply via classes */
        .delay-1 { transition-delay: 0.18s; }
        .delay-2 { transition-delay: 0.34s; }
        .delay-3 { transition-delay: 0.52s; }

        /* small responsiveness/touch tweak: reduce translate distance */
        @media (max-width: 576px) {
            .fade-up { transform: translateY(18px); }
            .slide-in-left, .slide-in-right { transform: translateX(18px); }
        }

        /* optional polish */
        .contact-card { border: 0; }
        .contact-section .contact-card { transition: box-shadow 0.25s; }
        .contact-section .contact-card:hover { box-shadow: 0 8px 30px rgba(0,0,0,0.08); }
    `;

    // Intersection Observer that adds .animate when elements are visible
    useEffect(() => {
        const items = document.querySelectorAll(".fade-up, .slide-in-left, .slide-in-right");

        if (!items.length) return;

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            {
                threshold: 0.18,
            }
        );

        items.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    return (
        <div>
            {/* inject internal CSS */}
            <style>{css}</style>

            {/* 🌐 Navbar */}
            <Header />

            {/* 📩 Contact Section */}
            <section className="contact-section py-5 bg-light">
                <Container>
                    <h2 className="text-center fw-bold text-danger mb-4 fade-up">Get in Touch</h2>
                    <p className="text-center text-muted mb-5 fade-up delay-1">
                        Have a question, custom design request, or feedback? We’d love to hear from you!
                        Our team is always ready to help bring your ideas to life.
                    </p>

                    <Row className="align-items-stretch">
                        {/* Left: Contact Information (slide from left) */}
                        <Col md={5} className="mb-4 mb-md-0 d-flex">
                            <div className="p-4 bg-white rounded shadow-sm flex-fill contact-card slide-in-left delay-1">
                                <h5 className="fw-bold mb-3 text-center">Contact Information</h5>

                                <p className="text-muted mb-3">
                                    <FaMapMarkerAlt className="text-danger me-2" />
                                    #222, 12th Main,3rd Cross.Saraswathipuram,Mysore 570009
                                </p>
                                <p className="text-muted mb-3">
                                    <FaPhone className="text-danger me-2" />
                                    +91 8951088742 | 7899788742
                                </p>
                                <p className="text-muted mb-3">
                                    <FaEnvelope className="text-danger me-2" />
                                    akulcreationsmysoreofficial@gmail.com
                                </p>

                                <p className="text-muted mb-3">
                                    <i className="bi bi-whatsapp text-success me-2"></i>
                                    WhatsApp: +91 8951088742 | 7899788742
                                </p>

                                <p className="text-muted mb-3">
                                    <i className="bi bi-clock text-danger me-2"></i>
                                    Working Hours: Mon - Sat | 10:00 AM - 7:00 PM
                                </p>
                            </div>
                        </Col>

                        {/* Right: Message Form (slide from right) */}
                        <Col md={7} className="d-flex">
                            <div className="p-4 bg-white rounded shadow-sm flex-fill contact-card slide-in-right delay-2">
                                <h5 className="fw-bold mb-3 text-center">Send Us a Message</h5>

                                <Form className="h-100 d-flex flex-column">
                                    <Form.Group className="mb-3" controlId="name">
                                        <Form.Control type="text" placeholder="Enter your name" />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="email">
                                        <Form.Control type="email" placeholder="Enter your email" />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="phone">
                                        <Form.Control type="text" placeholder="Enter your phone number" />
                                    </Form.Group>

                                    <Form.Group className="mb-3" controlId="message">
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            placeholder="Write your message here"
                                        />
                                    </Form.Group>

                                    <Button variant="danger" type="submit" className="w-100">
                                        Send Message
                                    </Button>
                                </Form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>


            <Footer />
        </div>
    );
}
